@if (assistant) {
    <div class="client-container d-flex flex-column">
    <div class="view">
        <!-- Tabs -->
        <mat-tab-group #matTabGroup [selectedIndex]="selectedIndex" (selectedTabChange)="onTabChange($event)">
            <mat-tab [disabled]="true">
                <ng-template mat-tab-label>
                    <div class="tab-header-label">
                        <span class="category"><small>Assistant</small></span>
                        <span class="object-name">{{ assistant.name }}</span>
                    </div>
                </ng-template>
                <!-- No content required -->
            </mat-tab>
            <mat-tab label="Overview">
                <div class="tab-content">
                    <app-assistant-report [metricsData]="reportData"></app-assistant-report>
                </div>
            </mat-tab>
            <!-- Settings Tab -->
            <mat-tab label="Settings">
                <div class="tab-content">
                    <app-client-object-settings [clientSettingsForm]="settingsForm"
                                                [object]="assistant"></app-client-object-settings>
                    <app-assistant-general-settings [assistant]="assistant"
                                                    [settingsForm]="settingsForm"
                                                    [verifiedDomains]="verifiedDomains"
                                                    [isDomainsLoading]="isDomainsLoading"></app-assistant-general-settings>
                </div>
            </mat-tab>
            <!-- Functions Tab -->
            <mat-tab label="Functions">
                @if (assistant) {
                    <div class="tab-content">
                        <app-assistant-function-manifest-preview
                                [assistantId]="assistant.id"></app-assistant-function-manifest-preview>
                        <app-listings (selectionChange)="onFunctionRefsChange($event)"
                                      [multiselect]="true"
                                      [selectedItems]="assistant.functionRefs"
                                      selectionObjectType="functions"
                                      selectionType="multi"></app-listings>
                    </div>
                }
            </mat-tab>
            <mat-tab label="Product Feeds">
                @if (assistant) {
                    <div class="tab-content">
                        <app-assistant-feed-binding-warnings
                                [warnings]="feedBindingWarnings"></app-assistant-feed-binding-warnings>
                        <app-listings (selectionChange)="onProductFeedRefsChange($event)"
                                      [multiselect]="true"
                                      [selectedItems]="assistant.productFeedRefs ?? []"
                                      selectionObjectType="product-feeds"
                                      selectionType="multi"></app-listings>
                    </div>
                }
            </mat-tab>
            <!-- Search Tabs -->
            <mat-tab label="Direct Search">
                @if (assistant) {
                    <div class="tab-content">
                        <app-listings (selectionChange)="onDirectFileRefsChange($event)"
                                      [disallowSelectionForIds]="vectorFileRefs"
                                      [multiselect]="true"
                                      [selectedItems]="directFileRefs"
                                      selectionObjectType="files"
                                      selectionType="multi"></app-listings>
                    </div>
                }
            </mat-tab>
            <mat-tab label="Vector Search">
                @if (assistant) {
                    <div class="tab-content">
                        <div class="d-flex p-3">
                            <mat-icon>info</mat-icon>
                            <span class="m-l-8">You can pick a separate set of files for Vector Search. Files selected in one tab are disabled in the other to avoid overlap. A dedicated vector store is recreated when you Save.</span>
                        </div>
                        <app-listings (selectionChange)="onVectorFileRefsChange($event)"
                                      [disallowSelectionForIds]="directFileRefs"
                                      [multiselect]="true"
                                      [selectedItems]="vectorFileRefs"
                                      selectionObjectType="files"
                                      selectionType="multi"></app-listings>
                    </div>
                }
            </mat-tab>
            <mat-tab label="Publishing">
                @if (assistant) {
                    <div class="tab-content publishing-tab">
                        <section class="publishing-panel">
                            <div>
                                <h3>Draft workflow</h3>
                                <p>
                                    Save a draft to validate and run the stored regression suite before publishing.
                                </p>
                            </div>
                            <div class="publishing-actions">
                                <button mat-raised-button color="primary"
                                        (click)="saveDraft()"
                                        [disabled]="isSaving || isDeleting || isProposing || isVersionAction || settingsForm.invalid">
                                    {{ isVersionAction ? 'Working...' : 'Save draft & test' }}
                                </button>
                                <button mat-raised-button color="accent"
                                        (click)="publishDraft()"
                                        [disabled]="isSaving || isDeleting || isProposing || isVersionAction || !activeDraft || !canPublishDraft()">
                                    Publish draft
                                </button>
                            </div>
                        </section>

                        <section class="regression-tests-panel">
                            <div class="panel-heading">
                                <div>
                                    <h3>Regression tests</h3>
                                    <p>Stored tests run automatically for draft saves, publishes, and rollbacks.</p>
                                </div>
                                <div class="publishing-actions">
                                    <button mat-button color="primary"
                                            (click)="addRegressionTestCase()"
                                            [disabled]="isVersionAction || isSavingRegressionTests">
                                        Add test
                                    </button>
                                    <button mat-raised-button color="primary"
                                            (click)="saveRegressionTests()"
                                            [disabled]="isVersionAction || isSavingRegressionTests">
                                        {{ isSavingRegressionTests ? 'Saving...' : 'Save tests' }}
                                    </button>
                                </div>
                            </div>

                            @if (regressionTestCases.length === 0) {
                                <p>No regression tests configured.</p>
                            } @else {
                                <div class="regression-tests-list">
                                    @for (testCase of regressionTestCases; track $index; let index = $index) {
                                        <div class="regression-test-row">
                                            <mat-checkbox [(ngModel)]="testCase.enabled"
                                                          [name]="'regression-enabled-' + index">
                                                Enabled
                                            </mat-checkbox>
                                            <mat-form-field appearance="outline">
                                                <mat-label>Name</mat-label>
                                                <input matInput [(ngModel)]="testCase.name"
                                                       [name]="'regression-name-' + index">
                                            </mat-form-field>
                                            <mat-form-field appearance="outline">
                                                <mat-label>Instructions contain</mat-label>
                                                <input matInput [(ngModel)]="testCase.expectedInstructionsContains"
                                                       [name]="'regression-expected-' + index">
                                            </mat-form-field>
                                            <mat-form-field appearance="outline">
                                                <mat-label>Instructions exclude</mat-label>
                                                <input matInput [(ngModel)]="testCase.forbiddenInstructionsContains"
                                                       [name]="'regression-forbidden-' + index">
                                            </mat-form-field>
                                            <mat-form-field appearance="outline">
                                                <mat-label>Model</mat-label>
                                                <input matInput [(ngModel)]="testCase.expectedModel"
                                                       [name]="'regression-model-' + index">
                                            </mat-form-field>
                                            <button mat-icon-button color="warn"
                                                    aria-label="Remove regression test"
                                                    (click)="removeRegressionTestCase(index)"
                                                    [disabled]="isVersionAction || isSavingRegressionTests">
                                                <mat-icon>delete</mat-icon>
                                            </button>
                                        </div>
                                    }
                                </div>
                            }
                        </section>

                        @if (activeDraft) {
                            <section class="version-status">
                                <div>
                                    <span class="status-label">Active draft</span>
                                    <strong>{{ activeDraft.id }}</strong>
                                </div>
                                <div>
                                    <span class="status-label">Validation</span>
                                    <strong [class.status-ok]="activeDraft.validationResult.passed"
                                            [class.status-fail]="!activeDraft.validationResult.passed">
                                        {{ activeDraft.validationResult.passed ? 'Passed' : 'Failed' }}
                                    </strong>
                                </div>
                                <div>
                                    <span class="status-label">Tests</span>
                                    <strong [class.status-ok]="activeDraft.testRunSummary.passed"
                                            [class.status-fail]="!activeDraft.testRunSummary.passed">
                                        {{ activeDraft.testRunSummary.passed ? 'Passed' : 'Failed' }}
                                    </strong>
                                </div>
                            </section>

                            @if (activeDraft.validationResult.errors.length) {
                                <div class="version-messages status-fail">
                                    @for (error of activeDraft.validationResult.errors; track error) {
                                        <div>{{ error }}</div>
                                    }
                                </div>
                            }
                            @if (activeDraft.validationResult.warnings.length) {
                                <div class="version-messages status-warning">
                                    @for (warning of activeDraft.validationResult.warnings; track warning) {
                                        <div>{{ warning }}</div>
                                    }
                                </div>
                            }
                        }

                        <section class="versions-list">
                            <h3>Version history</h3>
                            @if (assistantVersions.length === 0) {
                                <p>No assistant versions yet.</p>
                            } @else {
                                @for (version of assistantVersions; track version.id) {
                                    <div class="version-row">
                                        <div>
                                            <strong>{{ version.status }}</strong>
                                            <span>{{ version.createdAt | date:'short' }}</span>
                                            @if (version.publishedAt) {
                                                <span>Published {{ version.publishedAt | date:'short' }}</span>
                                            }
                                        </div>
                                        <button mat-button color="primary"
                                                (click)="rollback(version)"
                                                [disabled]="isVersionAction || version.status === 'draft'">
                                            Rollback
                                        </button>
                                    </div>
                                }
                            }
                        </section>
                    </div>
                }
            </mat-tab>
        </mat-tab-group>
        <!-- Save and Delete Buttons -->
        @if (showActionButtons) {
            <div class="action-buttons">
                <button (click)="save()" [disabled]="isSaving || isDeleting || isProposing || (!settingsForm.touched && !refsChanged)" color="primary"
                        mat-raised-button>
                    {{ isSaving ? 'Saving...' : 'Save' }}
                </button>
                <button (click)="delete()" [disabled]="isSaving || isDeleting || isProposing" color="warn"
                        mat-raised-button>
                    {{ isDeleting ? 'Deleting...' : 'Delete' }}
                </button>
        </div>
        }
    </div>
    </div>
}
